import React from 'react'
import MainResHeader from '../layout/MainResHeader'
import TopHeader from '../layout/TopHeader'
import Footer from '../layout/Footer'
import ContactMain from '../components/contact/ContactMain'
import ContactInfo from '../components/contact/ContactInfo'
import MainHeader from '../layout/MainHeader'
import { useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const ContactPage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  return (
    <div style={{ overflow:'hidden'}}>
    <HelmetProvider>
      <Helmet prioritizeSeoTags>
      <title>Contact | United Lab Care</title>
      <meta name="description" content="Contact Us for Covid-19, RSV, Influenza, and Respiratory Pathogen Panel testing services in Chicago IL." />
	<link rel="canonical" href="https://unitedlabcare.com/contact/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Contact | United Lab Care" />
	<meta property="og:description" content="Contact Us for Covid-19, RSV, Influenza, and Respiratory Pathogen Panel testing services in Chicago IL." />
	<meta property="og:url" content="https://unitedlabcare.com/contact/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-03-02T14:40:02+00:00" />
	<meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2022/12/United-Lab-Care-icon-v1.png" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="3 minutes" />
      </Helmet>
    </HelmetProvider>

        <TopHeader/>
        <MainResHeader/>
        {/* <MainHeader/> */}
        
        <ContactMain/>
        <ContactInfo/>


        <Footer/>
    </div>
  )
}

export default ContactPage